module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.0be9fa8f.ttf";